import isPayingSeller from '@repo/checkout/lib/isPayingSeller';

// Mirrors the API's fetchAllActiveSellers list; 'grow' sellers still exist
// pre-migration. Drop it in the follow-up PR.
const ALLOWED_PLAN_HANDLES = ['free', 'premium', 'launch', 'grow', 'scale', 'unlimited'];

/**
 * Whether to show real statistics rather than the "start a subscription" overlay.
 *
 * Mirrors the server-side `fetchAllActiveSellers` allowlist: if the aggregation
 * jobs skip a seller, there is nothing to show. Paying covers active, legacy and
 * comped.
 */
export default function checkHasStatisticsData(seller) {
  if (seller?.disabled) return false;

  if (!ALLOWED_PLAN_HANDLES.includes(seller?.plan?.handle)) {
    return false;
  }

  return (
    isPayingSeller(seller) ||
    seller?.subscriptionStatus === 'trialing' ||
    seller?.subscriptionStatus === 'free'
  );
}
